module.exports = __webpack_public_path__ + "media/icons-lj-styleguide-2025/external-link-4a27276e.svg";